import { Reveal, Overline } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export const HistoryFull = ({ t }) => (
  <section id="history-full" data-testid="history-full-section" className="py-24 md:py-36 bg-copou-ink text-white">
    <div className="max-w-4xl mx-auto px-6 md:px-12">
      <Reveal className="mb-12">
        <Overline>{t.historyFull.overline}</Overline>
        <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mt-4 text-white">{t.historyFull.title}</h2>
        <p className="mt-6 text-white/70 leading-relaxed text-base md:text-lg">{t.historyFull.intro}</p>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible defaultValue="chapter-0" className="w-full">
          {t.historyFull.chapters.map((c, i) => (
            <AccordionItem
              key={i}
              value={`chapter-${i}`}
              data-testid={`history-chapter-${i}`}
              className="border-white/15"
            >
              <AccordionTrigger className="font-serif text-lg md:text-xl text-white hover:no-underline hover:text-copou-primary py-6 [&>svg]:text-copou-primary">
                <span className="flex items-baseline gap-4 text-left">
                  <span className="text-copou-primary text-sm font-sans tabular-nums">{String(i + 1).padStart(2, "0")}</span>
                  {c.q}
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-white/70 leading-relaxed text-base pl-0 md:pl-10 pb-8">
                {c.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
